import { render } from "./HumanModel.vue?vue&type=template&id=238cbf48"
import script from "./HumanModel.vue?vue&type=script&lang=js"
export * from "./HumanModel.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__